import { render, staticRenderFns } from "./VerifyPdf.vue?vue&type=template&id=4bcee310&scoped=true&"
import script from "./VerifyPdf.vue?vue&type=script&lang=js&"
export * from "./VerifyPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcee310",
  null
  
)

export default component.exports